import Vue from 'vue';
import Vuex from 'vuex';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import App from './components/App';
import Helpers from "@mobile/helpers";
import router from './router';
import store from "@mobile/store";
import axios from 'axios';
import VueMoment from 'vue-moment';
import Loading from "vue-loading-overlay";
import VueI18n from 'vue-i18n';

axios.interceptors.request.use((config) => {
    config.headers['X-App-Version'] = store.state.appVersion;
    return config;
});

Vue.prototype.$http = axios;
Vue.prototype.console = console;
Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(Helpers);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.use(VueI18n);

Vue.filter('money', function (money) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });

    return formatter.format(money);
});


const token = localStorage.getItem('token');

if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueMoment);
Vue.use(Loading, {
    // props
    color: 'red',
    loader: 'spinner'
}, {
    // slots
});

Vue.mixin({
    methods: {
        isOutsideUser(user) {
            return OUTSIDE_ROLE_IDS.includes(user.role.id);
        },

        getUserCompany(companyId) {
            return this.$store.state.companies.find(company => Number(company.id) === Number(companyId));
        },

        hasManagerPermission(permission, companyId) {
            if (! companyId) {
                companyId = this.$store.state.company.id;
            }

            const company = this.getUserCompany(companyId);

            if (! company) {
                return false;
            }

            const permissionParts = permission.split('.');

            if(typeof company.permissions.manager[permissionParts[0]] === 'undefined' || typeof company.permissions.manager[permissionParts[0]][permissionParts[1]] === 'undefined'){
                return false;
            }

            return company.permissions.manager[permissionParts[0]][permissionParts[1]];
        }

    }
});


const messages = {
    "en": {
        "Product Name": "Product name",
        "Product Manufacturer": "Product Manufacturer",
        "Select product category": "Select product category",

        "Finnish": "Finnish",
        "Other": "Other",
        "Installed": "Installed",
        "Designed": "Designed",
        "Preliminary": "Preliminary",

        "On the floor": "On the floor",
        "On the ceiling": "On the ceiling",
        "On the wall": "On the wall",

        "Not approved": "Not approved",
        "Waiting": "Waiting",
        "Approved": "Approved",

        "You may use this to markup tool to present installed firestops": "You may use this to markup tool to present <u>installed</u> firestops",
        "Red pen": "Red pen",
        "You may use this tool for design": "You may use this tool for design",


        "Add detail into icon": "Add detail into icon",
        "In this section you can add optional details into your icon to be shown with the icon. You can skip this if wanted": "In this section you can add optional details into your icon to be shown with the icon. You can skip this if wanted",
        "Show detail": "Show detail",
        "Show running number": "Show running number",
        "Show short name": "Show short name",

        "Full Tool Name": "Full Tool Name",
        "Short Tool Name": "Short Tool Name",
        "shows on tablet / mobile": "shows on tablet / mobile",
        "Description": "Description",
        "optional": "optional",

        "Detail": "DETAIL",
        "In this section you can add optional details into your icon to be shown with the icon. You can skip this if wanted.": "In this section you can add optional details into your icon to be shown with the icon. You can skip this if wanted.",
        "Firestop Detail Name": "Firestop Detail Name",
        "Add a new detail": "Add a new detail",

        "Products": "Products",
        "Product": "Product",
        "Select a product to add it to your product list": "Select a product to add it to your product list",
        "Create a new product": "Create a new product",

        "Status": "Status",
        "This feature allows you to add dropdown selection box. Max 5 selections on one dropdown": "This feature allows you to add dropdown selection box. Max 5 selections on one dropdown",

        "Add another value": "Add another value",

        "Location": "Location",
        "Requires approval": "Requires approval",

        "Write description here": "Write description here",

        "Camera and gallery functions as a default": "Camera and gallery functions as a default",
        "Select Icon": "Icon",

        "Seam Foam": "Seam Foam",
        "Aerosols": "Aerosols",
        "Cuff": "Cuff",
        "Firestop Disk": "Firestop Disk",
        "Mass": "Mass",

        "This is a function where site requests approval or comment on this marking or the marking requires approval.": "This is a function where site requests approval or comment on this marking or the marking requires approval.",

        "Create new tool": "Create new tool",
        "Select Language / Region": "Select Language / Region",
        "Tool icon": "Tool icon",
        "Basic info": "Basic info",
        "Add details": "Add details",
        "Add products": "Add products",
        "Tool status": "Tool status",
        "Summary": "Summary",

        "Firestop details (as marked on the plan)": "Firestop details (as marked on the plan)",

        'firestop_tool': 'Fire Stop Tool',
        'custom_tool': 'General Tool',

        'arrow': 'Arrow',
        'multiline': 'Multiline',
        'area': 'Area',


        'This will appear as the default headline in your report for the tool (can be changed manually after adding the marking)': 'This will appear as the default headline in your report for the tool (can be changed manually after adding the marking)',
        'Max characters': 'Max characters {characters}',

        'This name appears in application, and helps to recognise between design markings': 'This name appears in application, and helps to recognise between design markings',
        "This tool description shows in tool's infobox, when descriptions is requested": "This tool description shows in tool's infobox, when descriptions is requested",

        'You may use this tool to draw multiple lines' : 'You may use this tool to draw multiple lines',
        'You may use this tool to point something out' : 'You may use this tool to point something out',
        'You may use this tool for selecting areas': 'You may use this tool for selecting areas',

        'Show tool type': 'Show tool type',

        'Select color': 'Select color',
        'Icon colors can be changed independently on each marking': 'Icon colors can be changed independently on each marking',

        'Add photo or album picture': 'Add photo or album picture',
        'This feature allows you to add picture for you marking from min to max pcs': 'This feature allows you to add picture for you marking from {min} to {max} pcs',

        'Add dropdown box': 'Add dropdown box',
        'This feature allows you to add dropdown selection box. You can have a maximum of x dropdowns and text boxes for a tool.': 'This feature allows you to add dropdown selection box. You can have a maximum of {max} dropdowns and text boxes for a tool.',
        'Max x selections on one dropdown': 'Max {max} selections on one dropdown',
        'Dropdown headline': 'Dropdown headline',
        'Add selection text' : 'Add selection text',
        'Add another selection box': 'Add another selection box',
        'Remove selection box' : 'Remove selection box',
        'Add another dropdown box': 'Add another dropdown box',
        'You have reached the maximum number of custom inputs (selection and text boxes)': 'You have reached the maximum number of custom inputs (selection and text boxes)',

        'Add text box': 'Add text box',
        'Text box headline': 'Text box headline',
        'Add another text box': 'Add another text box',

        'Add custom color': 'Add custom color',
        'Remove custom color': 'Remove custom color',
        'You can have': 'You can have',
        'custom colors.': 'custom colors.',
        'Click to change color': 'Click to change color'
    },
    "fi": {

        "Product Name": "Tuotenimi",
        "Product Manufacturer": "Valmistaja",
        "Select product category": "Valitse kategoria",

        "Finnish": "Suomi",
        "Other": "Other",
        "Installed": "Asennettu",
        "Designed": "Suunnittelussa",
        "Preliminary": "Keskeneräinen",

        "On the floor": "Lattiassa",
        "On the ceiling": "Katossa",
        "On the wall": "Seinässä",

        "Not approved": "Ei hyväksytty",
        "Waiting": "Odottaa",
        "Approved": "Hyväksytty",

        "You may use this to markup tool to present installed firestops": "Voit käyttää tätä merkintätapaa <u>asennettujen</u> palokatkojen merkitsemiseen.",
        "Red pen": "Punäkynä-merkintä (suunnittelu)",
        "You may use this tool for design": "Voit käyttää tätä merkintätapaa palokatkojen suunnitteluun",

        "Add detail into icon": "Määritä kuvakkeessa esitettävät tiedot",
        "In this section you can add optional details into your icon to be shown with the icon. You can skip this if wanted": "Tässä osiossa voit valita merkintään valinnaisia ​​tietoja, jotka näytetään kuvakkeen kanssa.",

        "Show detail": "Näytä detail",
        "Show running number": "Näytä juokseva numerointi",
        "Show short name": "Näytä työkalun lyhyt nimi",

        "Full Tool Name": "Merkintätyökalun nimi",
        "Short Tool Name": "Lyhynne",
        "shows on tablet / mobile": "näkyy mobiilissa ja merkinnässä",
        "Description": "Kuvaus",
        "optional": "vapaavalintainen",

        "Detail": "Detalji",
        "In this section you can add optional details into your icon to be shown with the icon. You can skip this if wanted.": "Tässä osiossa voit lisätä merkintätyökaluun lisätietoja, jotka näytetään mobiililaitteella merkintää lisätessä.",
        "Firestop Detail Name": "Palkatko detaili (suunnitelman lyhenne)",
        "Add a new detail": "Lisää uusi detaili",

        "Products": "Tuotteet",
        "Product": "Tuote",
        "Select a product to add it to your product list": "Valitse tuote valikosta ja lisää tuotelistaasi",
        "Create a new product": "Luo uusi tuote",

        "Status": "Asennuksen tila",
        "This feature allows you to add dropdown selection box. Max 5 selections on one dropdown": "Tämä toiminto mahdollistaa alasvetovalikoiden lisäämisen max 5 kpl",

        "Add another value": "Lisää uusi alasvetovalikko",

        "Location": "Sijainti",
        "Requires approval": "Vaadi hyväksyntä",

        "Write description here": "Lisätietoja",

        "Camera and gallery functions as a default": "Kuvien ottaminen ja liittäminen oletuksena",
        "Select Icon": "Valitse kuvake",

        "Seam Foam": "Saumavaahto",
        "Aerosols": "Aerosoli",
        "Cuff": "Mansetti",
        "Firestop Disk": "Palokatkolevy",
        "Mass": "Massa",

        "This is a function where site requests approval or comment on this marking or the marking requires approval.": "Tämän osion päällekytkentä antaa mahdollisuuden näyttää värikoodein palokatkon tilanteen, \"ei hyväksytty\", \"odottaa\" tai \"hyväksytty\".",

        "Create new tool": "Create new tool",
        "Select Language / Region": "Select Language / Region",
        "Tool icon": "Tool icon",
        "Basic info": "Basic info",
        "Add details": "Add details",
        "Add products": "Add products",
        "Tool status": "Tool status",
        "Summary": "Summary",

        "Firestop details (as marked on the plan)": "Palokatko detalji (kuten merkitty suunnitelmassa)",

        'firestop_tool': 'Fire Stop Tool',
        'custom_tool': 'General Tool',

        'arrow': 'Arrow',
        'multiline': 'Multiline',
        'area': 'Area',

        'This will appear as the default headline in your report for the tool (can be changed manually after adding the marking)': 'Tämä teksti näkyy työkalun oletusotsikona (voidaan muuttaa manuaalisesti merkinnän lisäämisen jälkeen)',
        'Max characters': 'Enintään {characters} merkkiä',

        'This name appears in application, and helps to recognise between design markings': 'Tämä lyhenne näkyy mobiilisovelluksessa työkalua valittaessa. Lyhenne auttaa tunnistamaan eri merkintätyökalut toisistaan',
        "This tool description shows in tool's infobox, when descriptions is requested": 'Tämä työkalun kuvaus näkyy työkalun tietoruudussa, kun luodusta työkalusta halutaan saada tarkempaa informaatiota',

        'You may use this tool to draw multiple lines' : 'Tämän työkalun avulla voit piirtää yhteisesti jatkuvan viivan',
        'You may use this tool to point something out' : 'Voit käyttää tätä työkalua osoittamaan yksityiskohtaa',
        'You may use this tool for selecting areas': 'Tätä työkalua voidaan käyttää laajojen alueiden merkitsemiseen',

        'Show tool type': 'Näytä tyyppi',

        'Select color': 'Valitse väri',
        'Icon colors can be changed independently on each marking': 'Ikonin värin voi vaihtaa jokaisen merkinnän osalta',

        'Add photo or album picture': 'LISÄÄ VALOKUVA- TAI ALBUMIKUVA ',
        'This feature allows you to add picture for you marking from min to max pcs': 'Tämän ominaisuuden avulla voit lisätä kuvan / kuvia merkintääsi {min}-{max} kpl',


        'Add dropdown box': 'LISÄÄ ALASVETOVALIKKO',
        'This feature allows you to add dropdown selection box. You can have a maximum of x dropdowns and text boxes for a tool.': 'Tämän ominaisuuden avulla voit lisätä alasvetovalikon. Työkalulla voi olla enintään {max} avattavaa alasvetovalintaa (otsikkoa).',
        'Max x selections on one dropdown': 'Enintään {max} erillistä valintaa yhdellä avattavalla valikolla / otsikolla.',
        'Dropdown headline': 'Alasvetovalikon otsikko',
        'Add selection text' : 'Lisää valintateksti',
        'Add another selection box': 'Lisää toinen valintaruutu',
        'Remove selection box' : 'Poista valintaruutu',
        'Add another dropdown box': 'Lisää toinen avattava valikko',
        'You have reached the maximum number of custom inputs (selection and text boxes)': 'Olet saavuttanut mukautettujen syötteiden (valinta- ja tekstikenttien) enimmäismäärän.',

        'Add text box': 'LISÄÄ TEKSTIRUUTU',
        'Text box headline': 'Tekstiruudun otsikko (*) Eli tieto, jota halutaan työmaalta',
        'Add another text box': 'Lisää uusi tekstiruutu',

        'Add custom color': 'Lisää mukautettu väri',
        'Remove custom color': 'Poista mukautettu väri',
        'You can have': 'Voit lisätä enintään',
        'custom colors.': 'mukautettuja värejä.',
        'Click to change color': 'Klikkaa vaihtaaksesi väriä'
    }
}

export const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    messages
});

export const OUTSIDE_ROLE_IDS = [6,5];


const app = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
});
